import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconImage = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--image")} iconColor={color} size={size} width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

      <defs>
          <path d="M19,2 C20.6568542,2 22,3.34314575 22,5 L22,19 C22,20.6568542 20.6568542,22 19,22 L5,22 L4.94195983,21.9983247 C4.94162942,21.9983056 4.94129901,21.9982863 4.94096861,21.9982669 L5,22 C3.34314575,22 2,20.6568542 2,19 L2,5 C2,3.34314575 3.34314575,2 5,2 L19,2 Z M16,11.4142136 L7.414,20 L19,20 C19.5522847,20 20,19.5522847 20,19 L20,15.415 L16,11.4142136 Z M19,4 L5,4 C4.44771525,4 4,4.44771525 4,5 L4,19 C4,19.4289102 4.27002785,19.794752 4.64935664,19.9367986 L15.2928932,9.29289322 C15.6834175,8.90236893 16.3165825,8.90236893 16.7071068,9.29289322 L16.7071068,9.29289322 L20,12.585 L20,5 C20,4.44771525 19.5522847,4 19,4 Z M8.5,6 C9.88071187,6 11,7.11928813 11,8.5 C11,9.88071187 9.88071187,11 8.5,11 C7.11928813,11 6,9.88071187 6,8.5 C6,7.11928813 7.11928813,6 8.5,6 Z M8.5,8 C8.22385763,8 8,8.22385763 8,8.5 C8,8.77614237 8.22385763,9 8.5,9 C8.77614237,9 9,8.77614237 9,8.5 C9,8.22385763 8.77614237,8 8.5,8 Z" id="icon--centivo--image"/>
      </defs>
      <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-1458.000000, -636.000000)"/>
          <g id="Icon/image">
              <mask id="mask-2" fill="white">
                  <use xlinkHref="#icon--centivo--image"/>
              </mask>
              <use id="Shape" fill="currentColor" xlinkHref="#icon--centivo--image"/>
          </g>
      </g>
  </IconWrapper>
)
